import { Store } from '@reduxjs/toolkit';
import { ReducersInjectorWithState, StoreType } from '@wajeez-web/stores/base';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { ContentAnalysisState } from './contentAnalysis/types';
import contentAnalysisReducer from './contentAnalysis/slices';
import { WajeezAnalysisState } from './wajeezQueriesAnalysis/types';
import wajeezQueriesAnalysisReducer from './wajeezQueriesAnalysis/slices';
import { PaymentAnalysisState } from './paymentAnalysis/types';
import paymentAnalysisReducer from './paymentAnalysis/slices';

export let appwatchStore: StoreType<{
  paymentAnalysis: PaymentAnalysisState;
  contentAnalysis: ContentAnalysisState;
  wajeezAnalysis: WajeezAnalysisState;
}>;

// export type StoreType = typeof store;
export type AppwatchDispatch = typeof appwatchStore.dispatch;
export type AppwatchStoreState = ReturnType<typeof appwatchStore.getState>;
export const useAppwatchDispatch = () => useDispatch<AppwatchDispatch>();
export const useAppwatchSelector: TypedUseSelectorHook<AppwatchStoreState> =
  useSelector;
export const getAppwatchState = (store: Store) =>
  store.getState() as AppwatchStoreState;

export const injectAppwatchReducers: ReducersInjectorWithState<
  AppwatchStoreState
> = () => {
  return [
    {
      name: 'paymentAnalysis',
      reducer: paymentAnalysisReducer,
    },
    {
      name: 'contentAnalysis',
      reducer: contentAnalysisReducer,
    },
    {
      name: 'wajeezAnalysis',
      reducer: wajeezQueriesAnalysisReducer,
    },
  ];
};
